import {
  LISTINGS_CLEAR_STORE,
  LISTINGS_FETCH_BY_OWNER_SPACES_SUCCESS,
  LISTINGS_FETCH_BY_SPACE_FAILURE,
  LISTINGS_FETCH_BY_SPACE_REQUEST,
  LISTINGS_FETCH_BY_SPACE_SUCCESS,
  LISTINGS_FETCH_FAILURE,
  LISTINGS_FETCH_REQUEST,
  LISTINGS_FETCH_SUCCESS,
} from "../constants/action-types";

const initialState = {
  isFetching: false,
  hasFetched: false,
  data: [],
  fetchError: null,
};

export default function listings(state = initialState, action) {
  const { data, fetchError, type } = action;

  if (LISTINGS_CLEAR_STORE === type) {
    return { ...initialState };
  }

  if (LISTINGS_FETCH_REQUEST === type) {
    return { ...state, isFetching: true };
  }

  if (LISTINGS_FETCH_SUCCESS === type) {
    return { ...state, data, hasFetched: true, isFetching: false };
  }

  if (LISTINGS_FETCH_FAILURE === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  if (LISTINGS_FETCH_BY_OWNER_SPACES_SUCCESS === type) {
    const { spaceIds } = action;
    const otherSpacesListings = (state.data || []).filter(
      (listing) => !spaceIds.includes(listing.parentSpaceId),
    );
    return {
      ...state,
      data: [...otherSpacesListings, ...data],
      hasFetched: true,
      isFetching: false,
    };
  }

  if (LISTINGS_FETCH_BY_SPACE_REQUEST === type) {
    return { ...state, isFetching: true };
  }

  if (LISTINGS_FETCH_BY_SPACE_SUCCESS === type) {
    return { ...state, data, hasFetched: true, isFetching: false };
  }

  if (LISTINGS_FETCH_BY_SPACE_FAILURE === type) {
    return { ...state, fetchError, hasFetched: true, isFetching: false };
  }

  return state;
}
